import React, { useState } from "react";
import { styled } from '@mui/material/styles';
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import { Box, Button, Card, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, InputBase, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material";
import SearchIcon from "src/svgComponents/SearchIcon";
import UserListHead from "src/components/user/UserListHead";
import { ORDERS } from "src/api/axios";
import { useQuery } from "react-query";
import { useEffect } from "react";
import { useSnackbar } from "notistack";
import { TablePagination } from "@material-ui/core";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { fDate } from "src/utils/formatTime";
import AppTooltip from "src/components/common/AppTooltip";
import moment from "moment";
import LoadingScreen from "src/components/LoadingScreen";

const CancelledOrders = () => {
   const [tableData, setTableData] = useState([]);
   const [page, setPage] = useState(0);
   const [rowsPerPage, setRowsPerPage] = useState(10);
   const [order, setOrder] = useState('desc');
   const [orderBy, setOrderBy] = useState('createdAt');
   const [filterName, setFilterName] = useState('');
   const [open, setIsOpen] = useState(false);
   const [orderDetailData, setOrderDetails] = useState('')
   const [openAltert, setOpenAlert] = useState(false);
   const [deleteId, setDeleteId] = useState('');
   const axiosPrivate = useAxiosPrivate();
   const { enqueueSnackbar } = useSnackbar();
   const [loading, setLoding] = useState(true);

   const StyledTableRow = styled(TableRow)(({ theme }) => ({
      '&:nth-of-type(odd)': {
         backgroundColor: '#ffffff',
      },
      '&:nth-of-type(even)': {
         background: "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), #F4F5F7",
      },
      // hide last border
      '& td, & th': {
         border: 0,
      },
   }));
   const TABLE_HEAD = [
      { id: 'name', label: 'Customer Name', alignRight: false },
      { id: 'email', label: 'Customer Email', alignRight: false },
      { id: 'mobile', label: 'Customer Mobile', alignRight: false },
      { id: 'order_id', label: 'Order ID', alignRight: false },
      { id: 'order on', label: 'Order on', alignRight: false },
      { id: 'order amount', label: 'Order amount', alignRight: false },
      { id: 'reject reason', label: 'Reject Reason', alignRight: false },
      { id: 'status', label: 'Status', alignRight: false },
      { id: 'action', label: 'Action', alignRight: false },
   ];

   function descendingComparator(a, b, orderBy) {
      if (b[orderBy] < a[orderBy]) {
         return -1;
      }
      if (b[orderBy] > a[orderBy]) {
         return 1;
      }
      return 0;
   }

   function getComparator(order, orderBy) {
      return order === 'desc'
         ? (a, b) => descendingComparator(a, b, orderBy)
         : (a, b) => -descendingComparator(a, b, orderBy);
   }
   function applySortFilter(array, comparator) {
      const stabilizedThis = array.map((el, index) => [el, index]);
      stabilizedThis.sort((a, b) => {
         const order = comparator(a[0], b[0]);
         if (order !== 0) return order;
         return a[1] - b[1];
      });
      return stabilizedThis.map((el) => el[0]);
   }

   const handleFilterByName = (event) => {
      setFilterName(event.target.value.trim());
      setPage(0);

   };
   const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
   };
   const handleChangePage = (event, newPage) => {
      setPage(newPage);
   };
   const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
      setTimeout(() => {
         refetch();
      }, 500);
   };
   async function getCompletedOrderById(page, filterName) {
      const response = await axiosPrivate.get(ORDERS.getOrderById, { params: { status: "3", page: page + 1, search: filterName, limit: rowsPerPage } })
      return response.data[0];
   }

   const { data: orderbyStatusList, refetch } = useQuery(['orderbyStatusList', page, filterName], () => getCompletedOrderById(page, filterName), { keepPreviousData: true, })

   useEffect(() => {
      if (orderbyStatusList) {
         setTableData(orderbyStatusList.data);
         setRowsPerPage(orderbyStatusList?.metadata.length != 0 ? orderbyStatusList?.metadata[0].limit : 10);
      }
      if (orderbyStatusList?.metadata.length != 0 && orderbyStatusList?.metadata[0].hasMoreData == true) {
         getCompletedOrderById(page + 1);
      }
      setTimeout(() => {
         setLoding(false);
      }, 1000)

   }, [orderbyStatusList])

   const filteredUsers = applySortFilter(tableData, getComparator(order, orderBy));

   // Dialoge  
   const handleOpenDialog = (data) => {
      if (data) {
         setIsOpen(!open);
         setOrderDetails(data)
      }
   }
   const handleCloseDialoge = () => {
      setIsOpen(!open);
   }

   const handleClose = () => {
      setOpenAlert(!openAltert);
   }

   const handleDeleteOrder = async () => {
      if (deleteId) {
         const response = await axiosPrivate.delete(ORDERS.deletePendingOrder + deleteId)
         if (response?.data?.message) {
            enqueueSnackbar(response?.data?.message, {
               variant: "success",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 2000,
            });
            setOpenAlert(!openAltert)
         }
      }
      refetch()
   }
   const CompleteOrder = filteredUsers.filter(list => list.status === 3).map((data) => {
      return data;
   })

   return (
      <>
         <LoadingScreen loading={loading} />
         <div className="dashboard_header mb-4">
            <h4 className="app_text_20_semibold mb-0 d-flex align-items-center">Cancel Orders</h4>
            <Paper component="form" className='dashboard_searchbox col-lg-4'>
               <IconButton>
                  <SearchIcon />
               </IconButton>
               <InputBase
                  fullWidth
                  sx={{ flex: 1 }}
                  placeholder="search ..."
                  onChange={(e) => handleFilterByName(e)}
                  onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
               />
            </Paper>
         </div>
         {/* Alert Dialoge */}
         <Dialog
            open={openAltert}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
         >
            <DialogTitle id="responsive-dialog-title" className='m-auto'>
               {"Are you sure you want to delete?"}
            </DialogTitle>
            <DialogContent>
               <Stack direction={"row"} spacing={2} justifyContent={'center'}>
                  <Button className="theme_button_view" variant="contained" autoFocus onClick={handleClose}>
                     Cancel
                  </Button>
                  <Button className="theme_button" variant="contained" onClick={handleDeleteOrder} autoFocus>
                     Delete
                  </Button>
               </Stack>
            </DialogContent>
         </Dialog>
         <Dialog fullWidth open={open} >
            <DialogTitle>Order Details</DialogTitle>
            <DialogContent>
               <Grid container spacing={2} sx={{ py: 2 }}>
                  <Grid item xs={12}>
                     <Divider
                        sx={{
                           borderColor: "#A6A6A6",
                        }}
                     />
                  </Grid>
                  <Grid item xs={12}>
                     <Box
                        display={"flex"}
                        justifyContent={"space-between"}
                        alignItems="center"
                     >
                        <Box>
                           <Typography className="app_text_16_semibold">
                              Order
                           </Typography>
                        </Box>
                        <Box>
                           {orderDetailData?.status === 0 && (
                              <Chip
                                 label="Pending"
                                 style={{ backgroundColor: "#E4A11B", color: "#fff" }}
                              />
                           )}
                           {orderDetailData?.status === 1 && (
                              <Chip
                                 label="In Progress"
                                 style={{ backgroundColor: "#54B4D3", color: "#fff" }}
                              />
                           )}
                           {orderDetailData?.status === 2 && (
                              <Chip
                                 label="Completed"
                                 style={{ backgroundColor: "#14A44D", color: "#fff" }}
                              />
                           )}
                           {orderDetailData?.status === 3 && (
                              <Chip
                                 label="Cancelled"
                                 style={{ backgroundColor: "#DC4C64", color: "#fff" }}
                              />
                           )}
                           {orderDetailData?.status === 4 && (
                              <Chip
                                 label="Ready For Deliver"
                                 style={{ backgroundColor: "#17A2B8", color: "#fff" }}
                              />
                           )}
                           {orderDetailData?.status === 5 && (
                              <Chip
                                 label="Out For Delivery"
                                 style={{ backgroundColor: "#007BFF", color: "#fff" }}
                              />
                           )}
                           {orderDetailData?.status === 6 && (
                              <Chip
                                 label="Returned"
                                 style={{ backgroundColor: "#800080", color: "#fff" }}
                              />
                           )}
                        </Box>
                     </Box>
                     {orderDetailData?.items ? (
                        <Box marginTop={2} boxShadow={"0px 1px 3px #A6A6A6"}>
                           <Table>
                              {orderDetailData?.items.map((row) => {
                                 return (
                                    <StyledTableRow key={row._id}>
                                       <TableCell>
                                          {row.item_name ? (
                                             <Stack display={"flex"} alignItems="flex-start" spacing={3} direction={"row"} >
                                                <Box
                                                   sx={{
                                                      height: "80px",
                                                      width: "80px",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                      borderRadius: "12px",
                                                      overflow: "hidden",
                                                   }}
                                                >
                                                   <img src={row?.image ? process.env.REACT_APP_PROFILE_URL + "foodItem/" + row?.image : ""} alt=""
                                                      style={{
                                                         height: "100%",
                                                         width: "100%",
                                                         objectFit: "cover",
                                                         objectPosition: "center",
                                                      }}
                                                   />
                                                </Box>
                                                <Box>
                                                   <h6>{row?.item_name}</h6>
                                                   <p>{row?.quantity + "x"}</p>
                                                </Box>
                                             </Stack>
                                          ) : (
                                             ""
                                          )}
                                       </TableCell>
                                       <TableCell style={{ display: "flex", alignItems: "center", justifyContent: "right" }}
                                       >
                                          <Typography className="app_text_14_semibold"> £{row?.total?.toFixed(2)} </Typography>
                                       </TableCell>
                                    </StyledTableRow>
                                 );
                              })}
                           </Table>
                        </Box>
                     ) : (
                        ""
                     )}
                  </Grid>
                  <Grid item xs={12}>
                     <Typography className="app_text_16_semibold">
                        Order Details
                     </Typography>
                     <Box sx={{ border: "1px solid gainsboro", padding: "16px" }} >
                        <Stack spacing={2}>
                           <Box>
                              <Typography className="app_text_14_semibold"> Order Number </Typography>
                              <Typography className="app_text_12_fw500 app_text_gray"> {orderDetailData?.order_id} </Typography>
                           </Box>
                           {/* <Box>
                              <Typography className="app_text_14_semibold"> Payment Type </Typography>
                              <Typography className="app_text_12_fw500 app_text_gray"> {orderDetailData?.payment_type} </Typography>
                           </Box> */}
                           <Box>
                              <Typography className="app_text_14_semibold"> Date </Typography>
                              <Typography className="app_text_12_fw500 app_text_gray"> {moment(orderDetailData?.createdAt).format("DD MMM YYYY")} </Typography>
                           </Box>
                           {
                              orderDetailData?.verification_otp ?
                                 <Box>
                                    <Typography className="app_text_14_semibold"> Verification OTP </Typography>
                                    <Typography className="app_text_12_fw500 app_text_gray"> {orderDetailData?.verification_otp} </Typography>
                                 </Box> : ''
                           }
                           <Box>
                              <Typography className="app_text_14_semibold"> {orderDetailData.mobile ? "Phone Number" : "Email"} </Typography>
                              <Typography className="app_text_12_fw500 app_text_gray">
                                 {orderDetailData?.mobile
                                    ? orderDetailData?.mobile
                                    : orderDetailData?.email}
                              </Typography>
                           </Box>
                           {
                              orderDetailData?.delivery_address ?
                                 <Box>
                                    <Typography className="app_text_14_semibold"> Deliver to </Typography>
                                    <Typography className="app_text_12_fw500 app_text_gray"> {orderDetailData?.delivery_address} </Typography>
                                 </Box> : ''
                           }
                           {
                              orderDetailData?.reject_reason ?
                                 <Box>
                                    <Typography className="app_text_14_semibold"> Reject Reason </Typography>
                                    <Typography className="app_text_12_fw500 app_text_gray"> {orderDetailData?.reject_reason} </Typography>
                                 </Box> : ''
                           }
                           {
                              orderDetailData?.is_pickup === false ?
                                 <Box>
                                    <Typography className="app_text_14_semibold"> Delivery Provider</Typography>
                                    <Typography className="app_text_12_fw500 app_text_gray"> {`${orderDetailData.delivery_by == 0 ? "Binox Delivery" : orderDetailData.delivery_by == 1 ? "Self Delivery" : ""}`} </Typography>
                                 </Box> : ''
                           }
                        </Stack>
                     </Box>
                  </Grid>
                  <Grid item xs={12}>
                     <Typography className="app_text_16_semibold"> Bill Details </Typography>
                     <Box
                        sx={{
                           border: "1px solid gainsboro",
                           // padding: "16px",
                        }}
                     >
                        <Table>
                           <StyledTableRow>
                              <TableCell>
                                 <Typography className="app_text_14_semibold"> Item Total </Typography>
                              </TableCell>
                              <TableCell align="right">
                                 <Typography className="app_text_14_semibold"> £{orderDetailData?.sub_total?.toFixed(2)} </Typography>
                              </TableCell>
                           </StyledTableRow>
                           <StyledTableRow>
                              <TableCell>
                                 <Typography className="app_text_14_semibold"> Tax </Typography>
                              </TableCell>
                              <TableCell align="right">
                                 <Typography className="app_text_14_semibold"> {orderDetailData?.tax?.toFixed(2)} % </Typography>
                              </TableCell>
                           </StyledTableRow>
                           {
                              orderDetailData?.is_pickup === false ?
                                 <StyledTableRow>
                                    <TableCell>
                                       <Typography className="app_text_14_semibold"> Delivery Charge </Typography>
                                    </TableCell>
                                    <TableCell align="right">
                                       <Typography className="app_text_14_semibold"> £{orderDetailData?.delivery_charge?.toFixed(2)} </Typography>
                                    </TableCell>
                                 </StyledTableRow> : ''
                           }

                           <TableRow> <TableCell colSpan={2}></TableCell> </TableRow>

                           <TableRow>
                              <TableCell style={{ borderBottom: "0" }}>
                                 <Typography className="app_text_14_semibold"> Total </Typography>
                              </TableCell>
                              <TableCell align="right" style={{ borderBottom: "0" }}>
                                 <Typography className="app_text_14_semibold"> £{orderDetailData?.total_amount?.toFixed(2)} </Typography>
                              </TableCell>
                           </TableRow>
                        </Table>
                     </Box>
                  </Grid>
               </Grid>
            </DialogContent>

            <DialogActions>
               <Button onClick={handleCloseDialoge} aria-label="delete" className="theme_button_view" variant="contained">
                  Close
               </Button>
            </DialogActions>
         </Dialog>
         <Card>
            <TableContainer>
               <Table>
                  <UserListHead
                     headLabel={TABLE_HEAD}
                     rowCount={0}
                     onRequestSort={handleRequestSort}
                  />
                  {CompleteOrder?.length > 0 ?
                     <TableBody>
                        {CompleteOrder.map((row, index) => {
                           return (
                              <StyledTableRow key={row._id}>
                                 <TableCell component="th" scope="row">
                                    {row?.user_data?.firstname ? row?.user_data?.firstname + ' ' + row?.user_data?.lastname : '-'}
                                 </TableCell>
                                 <TableCell component="th" scope="row">
                                    {row?.user_data?.email ?? '-'}
                                 </TableCell>
                                 <TableCell component="th" scope="row">
                                    {row?.user_data?.mobile ?? '-'}
                                 </TableCell>
                                 <TableCell component="th" scope="row">
                                    {row?.order_id ?? '-'}
                                 </TableCell>
                                 <TableCell component="th" scope="row">
                                    {fDate(row?.createdAt)}
                                 </TableCell>
                                 <TableCell component="th" scope="row">
                                    £{row?.total_amount?.toFixed(2)}
                                 </TableCell>
                                 <TableCell component="th" scope="row">
                                    {/* {fDate(row?.createdAt)} */}
                                    {row?.reject_reason ?? "-"}
                                 </TableCell>
                                 <TableCell>
                                    <Stack direction="row" spacing={3}>
                                       {
                                          row.status === 3 && <Chip
                                             label="Cancelled"
                                             style={{ backgroundColor: "#DC4C64", color: "#fff" }}
                                          />
                                       }
                                    </Stack>
                                 </TableCell>
                                 <TableCell component="th" scope="row">
                                    <Stack direction="row" spacing={3}>
                                       <AppTooltip title="View Order" placement="bottom">
                                          <Button variant="text" className="user_list_row_btn" onClick={() => handleOpenDialog(row)} ><VisibilityIcon /></Button>
                                       </AppTooltip>
                                       {/* {permissionsData?.completed_order?.substring(2, 3) == "1" ?
                                       <AppTooltip title="Delete Order" placement="bottom">
                                          <Button variant="text" className="user_list_row_btn" onClick={() => { handleOpen(row._id) }} ><BinIcon /></Button>
                                       </AppTooltip> : ''} */}
                                    </Stack>
                                 </TableCell>
                              </StyledTableRow>
                           )
                        })}
                     </TableBody>
                     :
                     <TableBody>
                        <TableRow>
                           <TableCell align="center" colSpan={9} sx={{ py: 5 }}>
                              <span className="app_text_16_semibold">No Data Found</span>
                           </TableCell>
                        </TableRow>
                     </TableBody>}
               </Table>
            </TableContainer>
            <TablePagination
               component="div"
               rowsPerPageOptions={[10, 20, 50, 100]}
               count={orderbyStatusList?.metadata.length != 0 ? orderbyStatusList?.metadata[0].total : 0}
               rowsPerPage={rowsPerPage}
               page={page}
               onPageChange={handleChangePage}
               onRowsPerPageChange={handleChangeRowsPerPage}
            />
         </Card>
      </>
   )
}

export default CancelledOrders